/* eslint-disable */

import girl1 from "../assets/svg/testimonials/girl1.svg";
import girl2 from "../assets/svg/testimonials/girl2.svg";
import girl3 from "../assets/svg/testimonials/girl3.svg";
import boy1 from "../assets/svg/testimonials/boy1.svg";
import boy2 from "../assets/svg/testimonials/boy2.svg";
import boy3 from "../assets/svg/testimonials/boy3.svg";

export const testimonialsData = [
  {
    id: 1,
    name: "James Wilson",
    title: "Startup Founder",
    text: "Muhammad Abubakar delivered our web application with excellent quality and attention to detail. His technical expertise and communication made the entire development process smooth and efficient.",
    image: boy1,
  },
  {
    id: 2,
    name: "Sophia Carter",
    title: "Business Owner",
    text: "Working with Abubakar was a great experience. He understood our requirements quickly and built a modern, responsive website that exceeded our expectations.",
    image: girl1,
  },
  {
    id: 3,
    name: "Ahmed Khan",
    title: "Product Manager",
    text: "From planning to deployment, Muhammad demonstrated professionalism and strong problem-solving skills. I highly recommend him for web and AI development projects.",
    image: boy2,
  },
  {
    id: 4,
    name: "Emily Johnson",
    title: "Marketing Director",
    text: "Our company needed a fast, scalable website, and Muhammad delivered exactly that. The design, performance, and user experience were outstanding.",
    image: girl2,
  },
  {
    id: 5,
    name: "Daniel Roberts",
    title: "CEO",
    text: "Muhammad combines technical expertise with creativity. He built a high-quality solution that helped improve our online presence and business operations.",
    image: boy3,
  },
  {
    id: 6,
    name: "Olivia Brown",
    title: "Entrepreneur",
    text: "Professional, reliable, and highly skilled. Muhammad delivered our project on time while maintaining excellent code quality and a great user experience.",
    image: girl3,
  },
];